import React from 'react';
import { 
  HelpCircle, 
  CreditCard, 
  Clock, 
  Percent, 
  FileText, 
  Shield, 
  Zap, 
  TrendingUp,
  Globe,
  DollarSign
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Globe,
      title: 'Валютные риски',
      description: 'Колебания курса валют могут значительно повлиять на ваш платеж в рублях. Оценивайте перспективы валюты на весь срок кредита.'
    },
    {
      icon: DollarSign,
      title: 'Источник дохода',
      description: 'Валютную ипотеку стоит рассматривать, если у вас есть стабильный доход в той же валюте, что и кредит.'
    },
    {
      icon: CreditCard,
      title: 'Низкие ставки',
      description: 'Основное преимущество валютной ипотеки – более низкие процентные ставки по сравнению с рублевыми кредитами.'
    },
    {
      icon: Clock,
      title: 'Срок кредита',
      description: 'Чем дольше срок валютной ипотеки, тем выше валютные риски. Оптимально выбирать более короткие сроки.'
    },
    {
      icon: Percent,
      title: 'Ставка vs Курс',
      description: 'Разница между рублевой и валютной ставкой должна быть достаточной, чтобы компенсировать возможные валютные риски.'
    },
    {
      icon: Shield,
      title: 'Страхование',
      description: 'Рассмотрите возможность хеджирования валютных рисков или специальных страховых продуктов для защиты от колебаний курса.'
    },
    {
      icon: Zap,
      title: 'Досрочное погашение',
      description: 'Увеличивайте платежи при укреплении рубля, чтобы быстрее погасить валютный кредит в благоприятные периоды.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по валютной ипотеке
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <TrendingUp className="w-5 h-5 text-amber-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-amber-700 dark:text-amber-300 mb-2">
              Бесплатная консультация
            </h4>
            <p className="text-xs text-amber-600 dark:text-amber-400 mb-3">
              Решение о валютной ипотеке лучше принимать после консультации со специалистом по финансовому планированию.
            </p>
            <button className="w-full py-1.5 text-xs bg-amber-500 text-white rounded hover:bg-amber-600 transition-colors">
              Подобрать консультанта
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;